<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >系统服务</el-breadcrumb-item>
          <el-breadcrumb-item >关于系统</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="content">
      <!-- <div class="logo">

      </div> -->
      <div class="base">
          <img src="../../assets/image/logo1.png" alt="" srcset="">
          <p style="font-size: 28px;margin-top: 22px;font-weight: 800;">数据管理软件</p>
          <p style="margin-top: 3px;">版本：<span>{{Ver}}</span></p>
          <!-- <p>导向医疗产品数据中心系统，由上海导向医疗系统有限公司搭建，帮助企业更好地进行信息化建设，方便快捷，让企业告别了繁琐、易出错的人工服务，帮助决策层做出更科学的规划。</p> -->
          <!-- <p style="margin-top: 60px;"><span>Copyright  ©  上海导向医疗系统有限公司  All Rights Reserved</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>沪ICP备19046950号-1</span></p> -->
          <!-- <p style="margin-top: 40px;display: flex;flex-direction: row;align-items: center;justify-content: center;"><img src="../../assets/image/beian.png" alt=""><span style="margin-left: 5px;">沪公网安备 31011502016064号</span></p> -->
      </div>
      <!-- <div class="document">
      </div> -->
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        Ver: '',
      }
    },
    methods:{
      getVersion(){
        this.Ver = 'AT18S12.V'+require('../../../package.json').version;
        // alert(this.Ver)
      },
    },
    mounted(){
      this.getVersion()
    }
  }
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;

  .content{
    color: #fff;

    .base{
      margin-top: 160px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

    }

    .document{
      margin-top: 200px;

      .document-left{
        float:left;
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .wechat{
        float:right;
        width: 20%;

        img{
          float: right;
          width:200px;
          height: 200px;
          margin-top: 40px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/about.vue